export default __webpack_public_path__ + "static/media/kv_m.2309e31c.png";